import { GoogleLogo } from "@phosphor-icons/react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1767785990437-dfe1fe516fe8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwa2l0Y2hlbiUyMGNoZWYlMjBjb29raW5nJTIwYmx1cnxlbnwwfHx8fDE3NzE2MjkxNjR8MA&ixlib=rb-4.1.0&q=85')`
        }}
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60" />
      
      {/* Login Card */}
      <div className="relative z-10 w-full max-w-md mx-4">
        <div className="bg-white rounded-xl p-8 shadow-2xl">
          <div className="flex items-center justify-center mb-8">
            <img src="/logo.png" alt="URCOGS" className="h-24" />
          </div>
          
          <p className="text-center text-muted-foreground mb-8">
            Multi-location inventory management
          </p>
          
          <button
            onClick={handleLogin}
            data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-3 bg-foreground text-white py-3 px-6 rounded-lg font-medium tracking-wide transition-all duration-200 hover:bg-foreground/90 hover:-translate-y-0.5"
          >
            <GoogleLogo size={20} weight="bold" />
            Continue with Google
          </button>
          
          <p className="text-center text-xs text-muted-foreground mt-6">
            By continuing, you agree to our Terms of Service
          </p>
        </div>
      </div>
    </div>
  );
}
